import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule, TooltipModule, PopoverModule } from 'ngx-bootstrap';

import { JobMatchMeetingsComponent } from './job-match-meetings.component';
import { JobMatchMeetingsFeedbackModalComponent } from './job-match-meetings-feedback-modal/job-match-meetings-feedback-modal.component';
import { FeedbackExecutionModule } from '../feedback-execution/feedback-execution.module';

@NgModule({
    declarations: [
        JobMatchMeetingsComponent,
        JobMatchMeetingsFeedbackModalComponent
    ],
    imports: [
        CommonModule,
        FeedbackExecutionModule,
        ModalModule.forRoot(),
        TooltipModule.forRoot(),
        PopoverModule.forRoot()
    ],
    exports: [
        JobMatchMeetingsComponent,
        JobMatchMeetingsFeedbackModalComponent
    ],
    entryComponents: [
        JobMatchMeetingsComponent,
        JobMatchMeetingsFeedbackModalComponent
    ]
})
export class JobMatchMeetingsModule { }
